import { strings } from '../strings';

/** Groups of the command palette, in display order (spec 6.1.11). */
export const PALETTE_GROUPS = ['goTo', 'blueprints', 'deployments', 'commands'] as const;
export type PaletteGroup = (typeof PALETTE_GROUPS)[number];

export interface PaletteEntry {
  id: string;
  group: PaletteGroup;
  label: string;
  keys?: string[];
  sequence?: boolean;
  run: () => void;
  /** The entry opens a next step in the palette (the network chooser) instead of closing it. */
  keepOpen?: boolean;
}

/** The palette's network commands (feature spec 17): each continues with the network chooser. */
export type NetworkCommand = 'go' | 'plan' | 'attach';

export const PALETTE_LIMIT = 50;

export function groupLabel(group: PaletteGroup): string {
  return strings.shell.palette.groups[group];
}

/**
 * Entries whose label or group name contains every word of the query (case-insensitive), in group order,
 * at most `limit`.
 */
export function filterPalette(
  entries: readonly PaletteEntry[],
  query: string,
  limit = PALETTE_LIMIT,
): PaletteEntry[] {
  const words = query.toLocaleLowerCase().split(/\s+/).filter(Boolean);
  const matches = entries.filter((entry) => {
    const text = `${entry.label} ${groupLabel(entry.group)}`.toLocaleLowerCase();
    return words.every((word) => text.includes(word));
  });
  const order = (entry: PaletteEntry) => PALETTE_GROUPS.indexOf(entry.group);
  return matches
    .map((entry, index) => ({ entry, index }))
    .sort((a, b) => order(a.entry) - order(b.entry) || a.index - b.index)
    .slice(0, limit)
    .map(({ entry }) => entry);
}
